import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { connectToStores } from 'fluxible-addons-react';
import { handleHistory, navigateAction } from 'fluxible-router';
import { SUCCESS } from '../models/request-status';
import { getNetwork as getMemoryNetwork, getSpotId, isDefaultNetwork } from '../services/app-state';
import { getTheme } from '../utils/theme-module';
import Navigation from './common/navigation/index';
import Login from './account/pages/login/index.old';
import ResetPassword from './account/pages/reset-password';
import TwoFactorAuthentication from './account/verification/TwoFactorAuthentication/TwoFactorAuthentication';
import Moderation from './moderation/index';
import { Analytics } from './analytics/index';
import AnalyticsNext from './analytics/analytics-next/AnalyticsNext';
import RevenueNext from './analytics/revenue-next/RevenueNext';
import Integrations from './features/index';
import Preferences from './preferences/index';
import VersionPreview from './version-preview/index';
import { DEFAULT_NETWORK_NAME } from 'app/scripts/models/network-types';
import PageNotFound from 'app/scripts/components/common/page-not-found';
import { analyticsEmbedPages } from '../configs/routes';
import classnames from 'classnames';
import { PageRoute } from 'app/scripts/configs/routeConstants';
import { SupportForm } from 'app/scripts/components/SupportForm/SupportForm';
import { connect } from 'react-redux';
import { track } from 'react-tracking';
import {
  getTimestamp,
  getUserRoles,
  SPOTIM_ANALYTICS,
  toAnalytics
} from 'app/scripts/tracking/sendEventUtils';
import { generateUuid } from 'app/scripts/utils/ids';
import { AnalyticsProvider } from 'app/scripts/services/analytics-provider';
import { SessionId } from 'app/scripts/session-id/SessionId';
import { UserLoggedIn } from 'app/scripts/components/common/UserLoggedIn/UserLoggedIn';
import { sendEvent } from '@spotim/send-events';
import { RolesContext } from '../../auth/roles-context/roles-context';
import { fetchInitSpotData, fetchSpotModerationData } from '../../spots/spotsActions';
import { checkRunningBulkActions } from 'app/scripts/components/moderation-v2/articles/reducers/loadArticlesSlice';

class Application extends Component {
  static displayName = 'Application';

  static propTypes = {
    context: PropTypes.object.isRequired,
    currentRoute: PropTypes.object.isRequired,
    pageTitle: PropTypes.string,
    spot: PropTypes.object,
    currentUser: PropTypes.object,
    has4O4Error: PropTypes.bool,
    spotId: PropTypes.string,
    checkRunningBulkActions: PropTypes.func
  };

  static contextType = RolesContext;

  async UNSAFE_componentWillReceiveProps(nextProps) {
    var { context } = this.props;
    var currentUser = nextProps.currentUser;
    if (this.props.currentUser.id && !currentUser.id && !this.props.isSpotChanging) {
      let network = getMemoryNetwork();
      let url = '/login';
      if (DEFAULT_NETWORK_NAME !== network.name) {
        url = `/network/${network.name}`;
      }
      context.executeAction(navigateAction, { url });
    }
  }

  async componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnMount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  @autobind
  handleScroll() {
    let mainNavElem = document.querySelector('.navigation-container');
    let secondaryNav = document.getElementsByClassName('filter-container');
    if (mainNavElem) {
      if (secondaryNav.length > 0 && secondaryNav[0].style.height === '79px') {
        if (window.scrollY > 0) {
          mainNavElem.className = 'navigation-container sticky';
        }
      } else {
        mainNavElem.className = 'navigation-container';
      }
    }
  }

  @autobind
  afterLoggedIn(spotId) {
    const { spot, context } = this.props;
    const isFetched = spot && spot.isFetched;

    if (!isFetched) {
      this.props.fetchInitSpotData(spotId);
      this.props.fetchSpotModerationData(spotId);
    }

    this.props.checkRunningBulkActions();
  }

  render() {
    if (this.props.has4O4Error) {
      return <PageNotFound />;
    }

    let component = null;
    let returnedContent = null;
    const { context, currentRoute, spot, currentUser, updatedCurrentUser } = this.props;

    var page = currentRoute.page;
    var navigationProps = {
      currentRoute,
      spot
    };
    var spotId = getSpotId() || currentRoute.params.spot_id;
    var userId = currentRoute.params.user_id;
    var ip = currentRoute.params.ip;
    var email = currentUser.email;
    var Handler = currentRoute.handler;
    var className = null;
    var usernameOrEmail = null;
    const { isAdmin, isModerationViewer, isSuperAdmin } = this.context;

    if (email) {
      className = email && !currentUser.isEmailVerified ? 'email-not-verified' : '';
    }

    const isEligibleForAdvancedPages = isAdmin || isSuperAdmin;

    switch (page) {
      case 'forgot-password':
      case 'login':
      case 'super-owner':
        navigationProps.visible = false;
        let props = {
          version: currentRoute.query.userVersion
        };
        const emailSent = currentRoute.query.email_sent;
        const passwordSet = currentRoute.query.password_set;

        if (emailSent) {
          props.message = 'Email sent! Please check your inbox.';
        } else if (passwordSet) {
          props.message = 'Password set! Please log in Below';
        }

        if (!isDefaultNetwork()) {
          props.disableSocialLogin = true;
        }

        returnedContent = <Handler {...props} />;
      case 'reset-password':
        navigationProps.visible = false;
        var ticket = currentRoute.query.spot_ticket;
        var status = currentRoute.query.spot_reset_password;
        if (ticket) {
          if (status === SUCCESS) {
            returnedContent = <ResetPassword ticket={ticket} />;
          } else {
            props = {
              expiredModal: true
            };
            component = <Login {...props} />;
          }
        }
        break;
      case 'two-factor-authentication':
        navigationProps.spotId = spotId;
        return (
          <div className="mfa-page">
            <TwoFactorAuthentication spotId={spotId} />
          </div>
        );
      case 'analytics-next':
        navigationProps.spotId = spotId;
        component = spot ? <AnalyticsNext spotId={spotId} page={page} /> : null;
        break;
      case 'revenue-next':
      case 'revenue-monetization':
        navigationProps.spotId = spotId;
        component = spot ? (
          <RevenueNext
            spotId={spotId}
            page={page}
            enableMonetization={spot.enableMonetization}
            isSuperAdmin={currentUser.isSuperAdmin}
          />
        ) : null;
        break;
      case 'analytics-overview':
      case 'analytics-monetization':
      case PageRoute.AnalyticsEmbedEngagement:
      case PageRoute.AnalyticsEmbedRevenue:
      case PageRoute.AnalyticsEmbedModeration:
        navigationProps.spotId = spotId;
        component = spot ? (
          <Analytics
            enableMonetization={spot.enableMonetization}
            isSuperAdmin={currentUser.isSuperAdmin}
            spotId={spotId}
            page={page}
            ssoEnabled={spot.ssoEnabled}
            isAuthorized={isEligibleForAdvancedPages}
          />
        ) : null;
        break;
      case 'moderation':
      case 'moderation-comments':
      case 'moderation-comments-folders':
      case 'moderation-posts':
      case 'moderation-posts-folders':
      case 'moderation-users':
      case 'user-search-results':
      case 'user-search-results-empty':
      case 'moderation-restricted-words':
      case 'moderation-users-blacklisted':
      case 'moderation-users-whitelisted':
      case 'moderation-advanced':
      case 'user-moderation':
      case 'ip-moderation':
      case 'moderation-articles':
        usernameOrEmail = currentRoute.params.user;
        let { params } = currentRoute;
        let conversationId = params.conv_id ? params.conv_id : null;
        let tag = params.tag ? params.tag : null;
        navigationProps.spotId = spotId;
        let top = !currentUser.isEmailVerified && currentUser.email ? 108 : 64;
        navigationProps.showLinks = !isModerationViewer;

        component = (
          <Moderation
            currentRoute={currentRoute}
            usernameOrEmail={usernameOrEmail}
            top={top}
            conversationId={conversationId}
            tag={tag}
            isAdmin={isAdmin}
            isSuperAdmin={currentUser.isSuperAdmin}
            isModerationViewer={isModerationViewer}
            className={className}
            page={page}
            ip={ip}
            spot={spot}
            currentUser={currentUser}
            spotId={spotId}
            userId={userId}
          />
        );
        break;
      case 'preferences-general':
      case 'preferences-design':
      case 'preferences-premissions':
      case 'preferences-advanced':
      case 'preferences-policy':
      case 'preferences-super-admin-settings':
      case 'preferences-super-admin-products':
      case 'preferences-single-sign-on':
      case 'preferences-super-admin':
      case 'preferences-css-variables':
      case 'preferences-conversation-feature-flags':
        navigationProps.spotId = spotId;

        component = (
          <Preferences
            currentUser={currentUser}
            spot={spot}
            page={page}
            context={context}
            spotId={spotId}
            isAuthenticated={isEligibleForAdvancedPages && spot}
          />
        );
        break;
      case 'features-conversation':
      case 'features-social':
      case 'features-broadcast':
      case 'features-reactions':
      case 'features-spotlight':
      case 'features-live-blog':
      case 'features-floating-bell':
      case 'features-topic-tracker':
        navigationProps.spotId = spotId;
        component = spot ? (
          <Integrations
            currentRoute={currentRoute}
            spot={spot}
            isAuthenticated={isEligibleForAdvancedPages}
          />
        ) : null;
        break;
      case 'page-not-found':
        returnedContent = <Handler />;
      case 'wordpress-setup-page':
        var spotName = currentRoute.query.name;
        returnedContent = <Handler spotId={spotId} spotName={spotName} />;
      case 'ticket-expired':
        returnedContent = <Handler />;
    }

    if (!returnedContent && spot && updatedCurrentUser && updatedCurrentUser.isRegistered) {
      const isFullWidthPage = analyticsEmbedPages.includes(page);

      returnedContent = (
        <div id="application-div" data-spotid={spotId} className={getTheme()}>
          <Navigation
            {...navigationProps}
            isAdmin={isAdmin}
            isSuperAdmin={isSuperAdmin}
            currentUser={currentUser}
            // to remount navigation after verification completed to refetch configs
            key="navigation"
          />
          <div className={classnames('main-layout', { 'full-width': isFullWidthPage })}>
            {component}
          </div>
          <VersionPreview />
        </div>
      );
    }

    return (
      <>
        {returnedContent}
        <SupportForm />
        <SessionId />
        <UserLoggedIn handler={this.afterLoggedIn} />
      </>
    );
  }

  async componentDidUpdate(prevProps) {
    const newProps = this.props;
    if (newProps.pageTitle !== prevProps.pageTitle) {
      document.title = newProps.pageTitle;
    }
  }
}

const TrackedApplication = track(
  props => {
    const { spotId, currentUser, updatedCurrentUser, currentRoute, sessionId } = props;
    const { id: user_id } = updatedCurrentUser;
    const { tabView, page } = currentRoute;
    const { first, secondary } = tabView || {};

    if (!tabView) {
      console.error(`tabView is not defined for ${page} page`);
    }

    // todo: align with BE why /cross request doesn't contain email and isModerationViewer, meanwhile use currentUser from flux
    const user_email = currentUser.email;

    return toAnalytics({
      spot_id: spotId,
      event_id: generateUuid(),
      user_id,
      user_email,
      roles: getUserRoles(updatedCurrentUser),
      // will be set by webpack
      version_id: HOST_PANEL_VERSION,
      timestamp: getTimestamp(),
      page: first,
      tab: secondary,
      session_id: sessionId,
      be_success: null
    });
  },
  {
    dispatch: data => {
      const { __type__: type, __analytics__: analytics, ...mixpanelData } = data;
      if (type === SPOTIM_ANALYTICS) {
        sendEvent(analytics);
      } else {
        const { eventName, ...restProps } = mixpanelData;
        if (!eventName) {
          return;
        }
        AnalyticsProvider.track(eventName, restProps);
      }
    }
  }
)(Application);

const AppConnectedToFluxStores = connectToStores(
  handleHistory(TrackedApplication),
  [],
  context => {}
);

const mapStateToProps = state => {
  return {
    updatedCurrentUser: state.currentUser,
    sessionId: state.application.sessionId,
    currentUser: state.currentUser,
    has4O4Error: state.application.is4O4Error,
    pageTitle: state.application.currentRoute?.title,
    spotId: state.application.spotId,
    isSpotChanging: state.spotSelector.isChanging,
    spot: state.spots.map[state.application.spotId]
  };
};

const mapDispatchToProps = dispatch => ({
  fetchInitSpotData: spotId => {
    dispatch(fetchInitSpotData(spotId));
  },
  fetchSpotModerationData: spotId => {
    dispatch(fetchSpotModerationData(spotId));
  },
  checkRunningBulkActions: () => {
    dispatch(checkRunningBulkActions());
  }
});

const AppConnectedToRedux = connect(mapStateToProps, mapDispatchToProps)(AppConnectedToFluxStores);

export default AppConnectedToRedux;
